import { Group, NumberInput, Stack } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import { BillingInfoBanner } from '../BudgetSettings/components/BillingInfoBanner';
import { CREDIT_PURCHASE_DEFAULTS, CREDIT_PURCHASE_LIMITS } from './constants';
import { useBuyCreditsModal } from './hooks';

interface BuyCreditsModalControllerProps {
	onPurchase: (amount: number) => void;
}

export function BuyCreditsModalController({
	onPurchase,
}: BuyCreditsModalControllerProps) {
	const {
		amount,
		amountError,
		error,
		isCreatingInvoice,
		handlePurchase,
		handleAmountChange,
		handleReset,
	} = useBuyCreditsModal({ onPurchase });

	return (
		<Stack spacing="md">
			<Text size="sm">
				Select the amount of credits you would like to purchase.
			</Text>
			<NumberInput
				label="Credit amount to purchase:"
				placeholder={`$${CREDIT_PURCHASE_DEFAULTS.AMOUNT}`}
				value={amount}
				onChange={handleAmountChange}
				min={CREDIT_PURCHASE_LIMITS.MIN}
				max={CREDIT_PURCHASE_LIMITS.MAX}
				step={CREDIT_PURCHASE_LIMITS.STEP}
				error={amountError}
			/>
			<BillingInfoBanner />
			<Group align="flex-end" w="100%" position="right">
				<Button
					disabled={isCreatingInvoice}
					variant="tertiary"
					onClick={handleReset}
				>
					Reset
				</Button>
				<Button
					variant="primary"
					onClick={handlePurchase}
					loading={isCreatingInvoice}
					disabled={!!amountError}
				>
					Purchase
				</Button>
				{error && (
					<Text size="sm" c="critical">
						{error}
					</Text>
				)}
			</Group>
		</Stack>
	);
}
